"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AdminProductDataMethods = require("./AdminProductDataMethods");
require("./AdminProductData.scss");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AdminProductData = _ref => {
  let {
    content,
    currentLanguageURL
  } = _ref;
  const {
    name,
    regions,
    translations,
    url,
    languageOptions
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-admin-product-data"
  }, name && /*#__PURE__*/_react.default.createElement("h4", {
    className: "luna-admin-product-data__name"
  }, name), regions && /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-admin-product-data__region-wrapper"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "luna-admin-product-data__regions"
  }, "Regions:"), (0, _AdminProductDataMethods.renderRegions)(regions)), translations && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, translations.map((translation, index) => {
    return /*#__PURE__*/_react.default.createElement(TranslationData, {
      key: translation.teaserName + index,
      content: translation,
      url: url,
      currentLanguageURL: currentLanguageURL,
      languageOptions: languageOptions
    });
  })), /*#__PURE__*/_react.default.createElement("div", null));
};
var _default = AdminProductData;
exports.default = _default;
const TranslationData = _ref2 => {
  let {
    content = {},
    url = "",
    currentLanguageURL,
    languageOptions = {}
  } = _ref2;
  const {
    language = "",
    teaserImage = {},
    teaserName = "",
    teaserText = ""
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-translation-data"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: teaserImage.url || teaserImage.src,
    alt: teaserName ? teaserName : ""
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "bold-me-pls"
  }, "Language:"), " ", languageOptions[language], " - ", language.toUpperCase()), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "bold-me-pls"
  }, "Card teaser name:"), " ", teaserName), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "bold-me-pls"
  }, "Card teaser text:"), " ", teaserText), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "bold-me-pls"
  }, "Normal URL:"), " ", /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    Link: content?.Link,
    className: mouse ? "" : "tabFocus",
    tabIndex: mouse ? "" : "0",
    to: `/${language}${url}`
  }, `/${language}${url}`)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "bold-me-pls"
  }, "QA URL:"), " ", /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    Link: content?.Link ? content?.Link : null,
    className: mouse ? "" : "tabFocus",
    tabIndex: mouse ? "" : "0",
    to: `/${currentLanguageURL}/admin${url}/${language}`
  }, `/admin${url}/${language}`))));
};
const truncateString = function (str) {
  let num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};